import { createAction } from '@reduxjs/toolkit';

export const OPEN_FILEPICKER = createAction('vtn-redact/OPEN_FILEPICKER');
export const actionOpenFilePicker = OPEN_FILEPICKER;

export const CLOSE_FILEPICKER = createAction('vtn-redact/CLOSE_FILEPICKER');
export const actionCloseFilePicker = CLOSE_FILEPICKER;

export const OPEN_FILEPICKER_URL = createAction(
  'vtn-redact/OPEN_FILEPICKER_URL'
);
export const actionOpenFilePickerUrl = OPEN_FILEPICKER_URL;

export const CLOSE_FILEPICKER_URL = createAction(
  'vtn-redact/CLOSE_FILEPICKER_URL'
);
export const actionCloseFilePickerUrl = CLOSE_FILEPICKER_URL;
